<template>
    <div id="HomePage">
        <div class="title-text animate-entry">
            <h1>{{ $t("welcomeMessage") }}</h1>
            <h3 v-html="$t('welcomeDescription')"></h3>
        </div>
        <div class="content animate-entry">
            <div>
                <div class="home-page-form">
                    <div class="form-row">
                        <div class="form-column">
                            <label for="name">{{ $t("name") }}</label>
                            <input type="text" id="name" name="name" v-model="name"
                                   :class="{'error': showErrors && !name}" :placeholder="$t('enterYourName')"
                                   @input="checkFormValidity">
                            <span v-if="showErrors && !name"
                                  class="mismatch-text">{{ $t("namespaceIsRequired") }}</span>
                        </div>
                        <div class="form-column">
                            <label for="lastName">{{ $t("surname") }}</label>
                            <input type="text" id="lastName" name="lastName" v-model="lastName"
                                   :class="{'error': showErrors && !lastName}" :placeholder="$t('enterYourLastName')"
                                   @input="checkFormValidity">
                            <span v-if="showErrors && !lastName"
                                  class="mismatch-text">{{ $t("theSurnameFieldIsRequired") }}</span>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-column">
                            <label for="password">{{ $t("password") }}</label>
                            <div class="password-container">
                                <input type="password" id="password" name="password" :placeholder="$t('password')"
                                       v-model="password" @input="validateForm">
                                <img
                                    :src="passwordVisible ? require('../../../assets/EyeOpen.png') : require('../../../assets/EyeClose.png')"
                                    class="toggle-password" @click="togglePasswordVisibility('password')">
                            </div>
                        </div>
                        <div class="form-column">
                            <label for="confirmPassword">{{ $t("passwordRedial") }}</label>
                            <div class="password-container" :class="{'mismatch': !passwordsMatch && confirmPassword}">
                                <input type="password" id="confirmPassword" name="confirmPassword"
                                       :placeholder="$t('passwordRedial')" v-model="confirmPassword">
                                <img
                                    :src="confirmPasswordVisible ? require('../../../assets/EyeOpen.png') : require('../../../assets/EyeClose.png')"
                                    class="toggle-password" @click="togglePasswordVisibility('confirmPassword')">
                            </div>
                            <span v-if="!passwordsMatch && confirmPassword"
                                  class="mismatch-text">Paralo Eşleşmiyor!</span>
                        </div>
                    </div>
                </div>
                <div class="info-container">
                    <div class="info-box info-box-left">
                        <div class="info-label">{{ $t("RegisteredEmail") }}</div>
                        <div class="info-value">{{ email }}</div>
                    </div>
                    <div class="info-box info-box-right">
                        <div class="info-label">{{ $t("siteName") }}</div>
                        <div class="info-value">{{ siteName }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formData, saveToLocalStorage, loadFromLocalStorage } from '../../../utils/formStore';

export default {
    name: "HomePage",
    props: {
        apiData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            password: formData.password || "",
            username: "example",
            confirmPassword: "",
            passwordVisible: false,
            confirmPasswordVisible: false,
            name: formData.name || "",
            lastName: formData.lastName || "",
            showErrors: false,
            email: this.getEmailFromUrl() || "",
        };
    },
    computed: {
        siteName() {
            if (this.apiData && this.apiData.clientAddress) {
                return this.apiData.clientAddress;
            }
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get("sitename") || "";
        },
        passwordsMatch() {
            return this.password === this.confirmPassword;
        },
        isFormValid() {
            return this.name &&
                this.lastName &&
                this.password &&
                this.confirmPassword &&
                this.passwordsMatch;
        },
    },
    methods: {
        getEmailFromUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('email');
        },
        checkFormValidity() {
            this.$emit("form-validity", this.isFormValid);
        },
        validateForm() {
            this.showErrors = true;
            this.checkFormValidity();
            return this.isFormValid;
        },
        togglePasswordVisibility(field) {
            if (field === "password") {
                this.passwordVisible = !this.passwordVisible;
                const passwordInput = document.getElementById("password");
                passwordInput.type = this.passwordVisible ? "text" : "password";
            } else if (field === "confirmPassword") {
                this.confirmPasswordVisible = !this.confirmPasswordVisible;
                const confirmPasswordInput = document.getElementById("confirmPassword");
                confirmPasswordInput.type = this.confirmPasswordVisible ? "text" : "password";
            }
            this.checkFormValidity();
        },
    },
    watch: {
        name(newVal) {
            saveToLocalStorage({ name: newVal });
        },
        lastName(newVal) {
            saveToLocalStorage({ lastName: newVal });
        },
        password(newVal) {
            formData.password = newVal;
            saveToLocalStorage({ password: newVal });
        },
        confirmPassword(newVal) {
            saveToLocalStorage({ confirmPassword: newVal });
            this.checkFormValidity();
        },
    },
    created() {
        const savedData = loadFromLocalStorage();
        this.name = savedData.name || '';
        this.lastName = savedData.lastName || '';
        this.password = savedData.password || '';
        this.confirmPassword = savedData.confirmPassword || '';
    },
};
</script>

<style lang="scss" scoped>
#HomePage {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    background-image: url("../../../assets/BackgroundOne.png");
    background-repeat: no-repeat;
    background-size: cover;

    .title-text {
        font-family: 'Plus Jakarta Sans', sans-serif;
        margin-bottom: 30px;

        h1 {
            color: #272657;
            font-weight: bold;
        }

        h3 {
            color: #64607D;
            font-weight: 100;
        }
    }

    .content {
        display: flex;
        justify-content: center;
        overflow: auto;

        .home-page-form {
            padding: 30px;
            background: #fff;
            width: 550px;
            border-radius: 20px;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);

            .form-row {
                display: flex;
                gap: 20px;
                justify-content: space-between;
                margin-bottom: 20px;

                .form-column {
                    display: flex;
                    flex-direction: column;
                    flex: 1;

                    label {
                        font-weight: bold;
                        margin-bottom: 5px;
                        color: #272657;
                        text-align: left;
                        margin-left: 12px;
                    }

                    input {
                        padding: 10px;
                        border: 1px solid #ccc;
                        border-radius: 5px;
                        font-size: 14px;
                        color: #6a6a6a;
                        height: 23px;

                        &::placeholder {
                            color: #ABA6C8;
                        }

                        &:focus {
                            outline: none;
                            border-color: #272657;
                        }

                        &:hover {
                            border-color: #272657;
                        }
                    }

                    .password-container {
                        position: relative;
                        display: flex;
                        align-items: center;

                        img {
                            width: 20px;
                        }

                        input {
                            flex: 1;
                            padding-right: 40px;
                        }

                        .toggle-password {
                            position: absolute;
                            right: 10px;
                            cursor: pointer;
                        }
                    }

                    .mismatch-text {
                        position: absolute;
                        color: red;
                        margin-top: 78px;

                    }

                    .mismatch input {
                        border-color: red;
                    }
                }
            }

            .description {
                text-align: left;
                color: #AFAFAF;
                margin-bottom: 15px;

                .initial {
                    color: #AFAFAF;
                }

                .valid {
                    color: #0AB611;
                }

                .invalid {
                    color: #FF5050;
                }

                > div:first-child {
                    margin-bottom: 10px;
                }

                > div {
                    display: flex;
                    justify-content: space-between;

                    ul {
                        list-style-type: disc;
                        padding-left: 20px;
                        color: #a6a6a6;
                        margin: 0;

                        li {
                            margin-bottom: 8px;
                        }
                    }
                }
            }
        }

        .info-container {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;

            .info-box {
                display: flex;
                flex-direction: column;
                padding: 10px;
                border-radius: 10px;
                width: 45%;

                .info-label {
                    color: #64607D;
                    margin-bottom: 5px;
                    text-align: center;
                }

                .info-value {
                    border-radius: 20px;
                    padding: 10px;
                    border: 2px solid #fff;
                    font-weight: bold;
                    text-align: center;
                    color: #272657;
                }
            }

            .info-box-left {
                text-align: left;
            }

            .info-box-right {
                text-align: right;
            }
        }
    }

    .animate-entry {
        opacity: 0;
        transform: translateY(-20px);
        animation: slideDown 0.8s ease forwards;
    }

    .content {
        animation-delay: 0.3s;
    }

    @keyframes slideDown {
        0% {
            opacity: 0;
            transform: translateY(-20px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .home-page-form {
        .form-row {
            opacity: 0;
            animation: fadeIn 0.5s ease forwards;

            &:nth-child(1) {
                animation-delay: 0.5s;
            }

            &:nth-child(2) {
                animation-delay: 0.7s;
            }
        }

        .description {
            opacity: 0;
            animation: fadeIn 0.5s ease forwards;
            animation-delay: 0.9s;
        }
    }

    .info-container {
        opacity: 0;
        animation: fadeIn 0.5s ease forwards;
        animation-delay: 1.1s;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media screen and (max-width: 768px) {
        .title-text {
            padding: 0 20px;
            margin-bottom: 20px;

            h1 {
                font-size: 1.8rem;
            }

            h3 {
                font-size: 1rem;
            }
        }

        .content {
            padding: 0 15px;

            .home-page-form {
                width: 100%;
                max-width: 100%;
                padding: 20px;
                height: auto;

                .form-row {
                    flex-direction: column;
                    gap: 15px;
                    margin-bottom: 15px;

                    .form-column {
                        width: 100%;

                        .mismatch-text {
                            margin-top: 45px;
                        }
                    }
                }

                .description {
                    > div {
                        flex-direction: column;

                        div {
                            width: 100%;
                            margin-bottom: 10px;
                        }

                        ul {
                            padding-left: 15px;

                            li {
                                margin-bottom: 5px;
                                font-size: 0.9rem;
                            }
                        }
                    }
                }
            }

            .info-container {
                flex-direction: column;
                gap: 15px;
                margin-top: 15px;

                .info-box {
                    width: 100%;

                    .info-value {
                        font-size: 0.9rem;
                        padding: 8px;
                    }
                }

                .info-box-left,
                .info-box-right {
                    text-align: center;
                }
            }
        }
    }

    @media screen and (max-width: 480px) {
        .title-text {
            h1 {
                font-size: 1.5rem;
            }

            h3 {
                font-size: 0.9rem;
            }
        }

        .content {
            .home-page-form {
                padding: 15px;

                .form-column {
                    label {
                        font-size: 0.9rem;
                    }

                    input {
                        font-size: 0.9rem;
                        height: 20px;
                    }
                }
            }
        }
    }

    @media screen and (min-width: 769px) and (max-width: 1024px) {
        .content {
            .home-page-form {
                width: 90%;
                max-width: 700px;
            }
        }
    }
}

.error {
    border-color: red !important;
}

.mismatch-text {
    position: absolute;
    color: red;
    font-size: 12px;
    margin-top: 45px;
}
</style>